import assertClassBrand from "./assertClassBrand.js";
export default function _classPrivateGetter(s, r, a) {
  return a(assertClassBrand(s, r));
}